<template>
  <Listbox
    v-model="selected_item"
    as="div"
    class="relative mr-5"
    :class="{ 'w-[70%]': shortKing }"
    @focusin="focusInput"
    @focusout="unfocusInput">
    <ListboxLabel
      v-if="label"
      :class="[
        isBoxBackground
          ? 'bg-light-box-background dark:bg-dark-box-background'
          : 'bg-light-screen-background dark:bg-dark-screen-background',
        isInputFocused || search_term ? '-top-0 text-sm' : 'top-[20px] text-base bg-transparent',
        isInputFocused ? 'text-light-brand-blue dark:text-dark-brand-blue' : ''
      ]"
      class="px-1 ml-10 z-20 h-fit text-common-grey absolute rounded-full transform transition-all -translate-y-1/2 left-2 select-none pointer-events-none ease-in-out duration-side-menu-transition-duration">
      {{ label }}
    </ListboxLabel>

    <div class="mt-1 z-10 flex rounded-md shadow-sm">
      <div class="relative flex items-stretch flex-grow focus-within:z-10">
        <div
          class="absolute -right-6 -top-6 bg-white border rounded-full cursor-pointer has-tooltip w-7 h-7 dark:border-dark-divider-border dark:bg-dark-screen-background"
          @click="$emit('close')">
          <X color="#FF0000" class="w-6 h-6 ml-[1px] mt-[1px] transition ease-in-out duration-side-menu-transition-duration" /><span
            class="inline-flex items-center gap-2 px-2 py-1 text-sm font-medium rounded-md tooltip whitespace-nowrap bg-light-screen-background dark:bg-dark-screen-background dark:text-dark-body-text">
            Close</span>
        </div>
        <input
          id="company-input"
          ref="inputComponent"
          v-model="search_term"
          :autofocus="true"
          :disabled="disabled"
          autocomplete="off"
          type="text"
          :class="[isBoxBackground ? 'bg-light-box-background dark:bg-dark-box-background' : 'bg-white dark:bg-dark-screen-background']"
          class="block pl-10 w-full rounded-lg re disabled:bg-gray-200 border border-light-divider-border dark:border-dark-divider-border shadow-sm placeholder-common-grey text-light-body-text dark:text-dark-body-text focus:outline-none focus:ring-light-brand-blue dark:focus:ring-dark-brand-blue focus:border-light-brand-blue dark:focus:border-dark-brand-blue text-sm transition ease-in-out duration-side-menu-transition-duration"
          @click="
            () => {
              search_results = data
              show_results = true
            }
          "
          @blur="
            () => {
              show_results = false
            }
          ">
        <span v-if="loading" id="companies-loading-component" class="absolute inset-y-0 right-6 flex items-center pr-2 pointer-events-none">
          <RotateCw class="animate-spin h-5 w-5 text-gray-500" aria-hidden="true" />
        </span>
        <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
          <Search class="h-5 w-5 text-gray-400" aria-hidden="true" />
        </div>
        <div v-if="!loading && !typeFilter" class="absolute inset-y-0 right-0 flex items-center">
          <div class="flex items-center dark:border-b-gray-500" @click="show_results = true">
            <div class="flex justify-between gap-1 pr-2">
              <div
                v-for="obj in all_object_types"
                :key="obj"
                class="px-1 flex justify-between items-center dark:text-dark-body-text border rounded-full shadow-sm py-0.5 text-left focus:outline-none sm:text-sm"
                :class="[selected_object_types.includes(obj) ? 'bg-[#0F9BD220] border-[#2DA7D7]' : '']"
                @click="filter(obj)">
                <span class="block truncate" :class="[selected_object_types.includes(obj) ? 'text-[#2DA7D7]' : 'text-common-grey']">{{
                  $utils.ObjectType(obj).label
                }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <button
        v-show="false"
        type="button"
        :class="
          isBoxBackground
            ? 'bg-light-box-background dark:bg-dark-box-background'
            : 'bg-light-screen-background dark:bg-dark-screen-background'
        "
        class="relative inline-flex items-center space-x-2 px-4 py-2 border border-light-divider-border dark:border-dark-divider-border text-sm font-medium focus:outline-none">
        <X class="h-5 w-5 text-gray-400 hover:text-gray-700" aria-hidden="true" @click="reset" />
      </button>
    </div>

    <transition
      v-show="search_results.length > 0 && show_results"
      leave-active-class="transition ease-in duration-100"
      leave-from-class="opacity-100"
      leave-to-class="opacity-0">
      <ListboxOptions
        id="user-panel"
        static
        :class="[
          isBoxBackground ? 'bg-white dark:bg-dark-box-background' : 'bg-white dark:bg-dark-box-background',
          { 'max-h-44 !-mt-52': openToTop }
        ]"
        class="absolute z-40 mt-1 w-full text-light-body-text dark:text-dark-body-text shadow-lg max-h-60 rounded-lg text-base ring-1 ring-black ring-opacity-5 overflow-auto focus:outline-none sm:text-sm transition ease-in-out duration-side-menu-transition-duration">
        <div id="companies-results-wrapper">
          <ListboxOption v-for="(company, i) in search_results" :key="company.id" as="template" :value="company">
            <li
              class="text-light-body-text cursor-pointer group hover:bg-light-brand-blue dark:hover:bg-dark-brand-blue relative transition ease-in-out duration-side-menu-transition-duration">
              <div :id="`company-${i}`" class="flex items-center border-b dark:border-b-gray-500 py-3">
                <Plus class="w-7 h-7 ml-3 text-dark-brand-blue group-hover:text-white" />
                <div class="flex flex-col ml-3">
                  <span
                    class="mb-1 font-bold text-[16px] block truncate group-hover:text-white dark:text-white"
                    :class="{ 'text-purple-700': company.id == 'passed_company' }">{{ Record.from(company).name ? Record.from(company).name : company.label }}</span>
                  <span
                    class="font-normal block truncate dark:text-gray-400 group-hover:text-white dark:group-hover:text-gray-300"
                    :class="{ 'text-purple-700': company.id == 'passed_company' }">{{ company.type }}</span>
                </div>
              </div>
            </li>
          </ListboxOption>
        </div>
      </ListboxOptions>
    </transition>
  </Listbox>
</template>

<script>
import { Listbox, ListboxOption, ListboxOptions, ListboxLabel } from "@headlessui/vue"
import dataService from "@/services/data.service"
import { Search, X, Plus, RotateCw } from "lucide-vue-next"
import { Record } from "@/models/record"
export default {
  components: {
    Plus,
    X,
    Listbox,
    ListboxOptions,
    ListboxOption,
    ListboxLabel,
    RotateCw,
    Search
  },
  props: {
    openToTop: null,
    shortKing: {
      type: Boolean,
      default: false
    },
    getOpportunities: {
      type: Boolean,
      default: false
    },
    typeFilter: {
      type: String,
      required: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    isBoxBackground: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      required: false
    },
    autoFocus: {
      type: Boolean,
      default: false
    },
    companies: {
      type: Array,
      default: () => []
    },
    autocompleteOptions: {
      type: Array,
      default: () => [],
      required: false
    }
  },
  emits: ["chosen", "close"],

  data() {
    return {
      Record,
      all_object_types: ["company", "opportunity"],
      selected_object_types: [],
      show_results: false,
      search_term: null,
      search_term_timeout: null,
      data: [],
      search_results: [],
      selected_item: null,
      isInputFocused: false,
      loading: false
    }
  },
  watch: {
    search_term() {
      clearTimeout(this.search_term_timeout)
      this.search_term_timeout = setTimeout(() => {
        this.loading = true
        let get_opportinuties
        if (this.$store.state.ui.currentCompany?.type == "company") {
          get_opportinuties = false
        } else {
          get_opportinuties = this.getOpportunities
        }
        this.search_results = []
        if (this.autocompleteOptions) {
          this.search_results.push(...this.autocompleteOptions)
        }
        dataService
          .getFilteredCompaniesAndOrOpportunities(this.search_term, get_opportinuties, this.typeFilter)
          .then((res) => {
            this.loading = false

            // this.search_results.push({ name: "Passed Company", id: "passed_company", type: "company", values: { [this.$store.state.integration.metrics_mapping.company_name_metric]: "Passed Company" } })
            res.data.results.forEach((item) => {
              if (!this.companies.find((company) => company.id == item.id) && this.selected_object_types.includes(item.type)) {
                this.search_results.push(item)
              }
            })
            this.show_results = true
          })
          .catch(() => {})
      }, 600)
    },
    selected_item() {
      if (this.selected_item) {
        this.$emit("chosen", { ...this.selected_item })
        this.search_term = null
        this.search_results = []
        this.show_results = false
        this.selected_item = null
      }
    },

    companies: {
      deep: true,
      handler() {
        this.loading = true
        let get_opportinuties
        if (this.$store.state.ui.currentCompany?.type == "company") {
          get_opportinuties = false
        } else {
          get_opportinuties = this.getOpportunities
        }
        this.search_results = []
        if (this.autocompleteOptions) {
          this.search_results.push(...this.autocompleteOptions)
        }
        dataService
          .getFilteredCompaniesAndOrOpportunities("", get_opportinuties, this.typeFilter)
          .then((res) => {
            this.loading = false
            // this.search_results.push({ name: "Passed Company", id: "passed_company", type: "company", values: { [this.$store.state.integration.metrics_mapping.company_name_metric]: "Passed Company" } })
            res.data.results.forEach((item) => {
              if (!this.companies.find((company) => company.id == item.id) && this.selected_object_types.includes(item.type)) {
                this.search_results.push(item)
              }
            })
            this.show_results = true
          })
          .catch(() => {})
      }
    }
  },

  created() {
    let selected_objects = this.$store?.state.object_types.filter((o) => this.all_object_types.includes(o.type))
    this.selected_object_types = [...new Set(selected_objects.map((o) => o.type))]
    if (this.autoFocus) {
      setTimeout(() => {
        const inputRef = this.$refs?.inputComponent
        inputRef?.focus()
      }, 500)

      this.loading = true
      dataService.getFilteredCompaniesAndOrOpportunities("", true, this.typeFilter).then((res) => {
        this.loading = false

        this.search_results = []
        if (this.autocompleteOptions) {
          this.search_results.push(...this.autocompleteOptions)
        }
        // this.search_results.push({ name: "Passed Company", id: "passed_company", type: "company", values: { [this.$store.state.integration.metrics_mapping.company_name_metric]: "Passed Company" } })
        res.data.results.forEach((item) => {
          if (!this.companies.find((company) => company.id == item.id) && this.selected_object_types.includes(item.type)) {
            this.search_results.push(item)
          }
        })

        this.data = this.search_results
        this.show_results = true
      })
    }
  },

  methods: {
    filter(object) {
      if (this.selected_object_types.includes(object)) {
        this.selected_object_types = this.selected_object_types.filter((o) => o != object)
      } else {
        this.selected_object_types.push(object)
      }
      clearTimeout(this.search_term_timeout)
      this.search_term_timeout = setTimeout(() => {
        this.loading = true
        this.search_results = []
        if (this.autocompleteOptions) {
          this.search_results.push(...this.autocompleteOptions)
        }
        dataService
          .getFilteredCompaniesAndOrOpportunities(this.search_term ? this.search_term : "", this.getOpportunities, this.typeFilter)
          .then((res) => {
            this.loading = false

            // this.search_results.push({ name: "Passed Company", id: "passed_company", type: "company", values: { [this.$store.state.integration.metrics_mapping.company_name_metric]: "Passed Company" } })
            res.data.results.forEach((item) => {
              if (!this.companies.find((company) => company.id == item.id) && this.selected_object_types.includes(item.type)) {
                this.search_results.push(item)
              }
            })
            this.show_results = true
          })
          .catch(() => {})
      }, 600)
    },
    focusInput() {
      this.isInputFocused = true
    },
    unfocusInput() {
      this.show_results = false
      this.isInputFocused = false
    },
    reset() {
      this.search_term = null
      this.search_results = []
      this.show_results = false
    }
  }
}
</script>
